import type { GeoJsonData } from '../PcaMap';
import type { FeatureType } from '../types';

export const addGeoJson = (
  map: google.maps.Map,
  geoJsonData: GeoJsonData,
  featureType?: FeatureType,
): { removeGeoJson: () => void } => {
  const importedFeatures = map.data.addGeoJson(geoJsonData);

  if (featureType)
    importedFeatures.forEach((feature) => {
      feature.setProperty('type', featureType);
    });

  return {
    removeGeoJson: () => {
      importedFeatures.forEach((feature) => map.data.remove(feature));
    },
  };
};
